export default __webpack_public_path__ + "static/media/news-icon.3f3564fb.svg";